import React, { useContext } from 'react';
import styled from 'styled-components';

import { ApplicationUIContext, colors } from '@yuhuinc/ui-library';
import { Typography, Menu, Divider, Spin } from 'antd';

import { getTranslatedString } from 'helpers/i18n';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const { Title, Text } = Typography;

const StyledContainer = styled.div`
  width: 295px;
  min-width: 295px;
  border: ${(props) => `1px solid ${colors.colors.neutral[5]}`};
  background: ${colors.colors.white[1]};
`;

const LessMarginDivider = styled(Divider)`
  margin: 8px 0px;
`;

const StyledTitle = styled(Title)`
  padding-left: 16px;
`;

const StyledMenuItem = styled(Menu.Item)`
  height: auto !important; // Antd menu item has a fixed height, so overriding this with auto
  margin: 0px !important; // Antd menu item has a fixed margin, so overriding this with 0px
`;

const StyledMenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0px;
`;

const StyledName = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.colors.neutral[10]};
`;

const StyledApplicantType = styled(Text)`
  line-height: 24px;
  color: ${colors.colors.neutral[7]};
`;

const ApplicantSelector = ({ selectedApplicantId, setSelectedApplicantId }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const currentApplication = useContext(CurrentApplicationContext);

  const applicants = currentApplication?.applicants || [];

  if (!applicants) {
    return <Spin />;
  }

  return (
    <React.Fragment>
      <StyledContainer>
        <StyledTitle level={isMobile ? 4 : 5}>Applicants</StyledTitle>
        <LessMarginDivider />
        <Menu
          selectedKeys={[selectedApplicantId]}
          onClick={({ key }) => setSelectedApplicantId(key)}
        >
          {applicants.map((applicant) => (
            <StyledMenuItem key={applicant.custom_id}>
              <StyledMenuItemContainer>
                <StyledName>{applicant.full_name}</StyledName>
                <StyledApplicantType>
                  {getTranslatedString(
                    `landlordPortal.applicationManagement.applicationOverview.overview.applicants.applicantTypes.${applicant.applicant_type}`
                  )}
                </StyledApplicantType>
              </StyledMenuItemContainer>
            </StyledMenuItem>
          ))}
        </Menu>
      </StyledContainer>
    </React.Fragment>
  );
};

export default ApplicantSelector;
